module.exports = __webpack_public_path__ + "img/logo.f5302aa3.png";